import appointmentJawTypes from '@constants/appointmentJawTypes'

export default [
  {
    value: appointmentJawTypes.BOTH,
    label: 'Both Jaws',
  },
  {
    value: appointmentJawTypes.SEPARATE,
    label: 'Separate Jaws',
  },
]
